module.exports = __webpack_public_path__ + "static/media/google-plus-icon.3095487f.png";